export const LOGIN_CANCELLATION = 'FACEBOOK_LOGIN_CANCELLATION'
export const LOGIN_NO_TOKEN = 'NO_TOKEN'
export const LOGIN_USER_DENY = 'USER_DENY_TO_LOGIN'
export const LOGIN_USER_DENY_MESSAGE = 'You haven’t logged in'

export const createError = (code, message = code) => {
  const err = new Error(message, code)
  err.errorCode = code
  return err
}

const NETWORK_ERROR_PATTERN = /timeout of \d|Network Error/

export const isNetworkError = err => {
  return err && NETWORK_ERROR_PATTERN.test(err.message)
}